import { resetALL } from "../../../../../.globals/redux/actions";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { clientQuery, clientMutation } from '../../../../../core/data/GraphQLApi';
import { endpoints } from '../../../../../core/defaultValues';
import { checkDeviceData } from 'Core/data/Helpers'

const INIT_STATE = {
    loadingPerformanceImprovement: false,
    performanceImprovement: [],
    updateDriverPerformanceCase: null,
    loadingUpdateDriverPerformanceCase: false,

    loadingRiskHistory: false,
    riskHistory: [],
    dateRange: null
};

export const searchPerformanceImprovement = createAsyncThunk(
    "driverPerformance/implovementPlanTab/searchPerformanceImprovement",
    async (payload, { rejectWithValue, getState }) => {
        try {
            const { caseId, driverId } = payload

            const response = await clientQuery(
                `
                query getDriverLivePerformance ($driverId: Int!, $caseId: Int!) {
                    data: getDriverLivePerformance (driverId: $driverId, caseId: $caseId)
                }`,
                {
                    driverId: driverId,
                    caseId: caseId
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            let data = checkDeviceData(response?.data)

            if (data) {
                const { dateRange, ...metrics } = data;
                const result = Object.entries(metrics).map(([key, value]) => ({
                    key,
                    value
                }));
                return { items: result || [], dateRange: dateRange || null }
            }

            return { items: [], dateRange: null }
        } catch (exc) {
            return []
        }
    }
);

export const updateDriverPerformanceCase = createAsyncThunk(
    "driverPerformance/implovementPlanTab/updateDriverPerformanceCase",
    async (payload, { rejectWithValue, getState }) => {
        try {
            const { id, coachId, statusId, notes, improvementOmit, targetAvgEvents, targetAvgEventsSuccess, targetRiskScore, targetRiskScoreSuccess, targetEvents, targetEventsSuccess, targetDistance, targetDistanceSuccess, updateStatus } = payload

            const response = await clientMutation(
                `
                mutation updateDriverPerformanceCase($id: Int!, $coachId: Int, $statusId: String!, $notes: String, $improvementOmit: Boolean, $targetAvgEvents: Float, $targetAvgEventsSuccess: Boolean, $targetRiskScore: Float, $targetRiskScoreSuccess: Boolean, $targetEvents: Float, $targetEventsSuccess: Boolean, $targetDistance: Float, $targetDistanceSuccess: Boolean) {
                    updateDriverPerformanceCase(id: $id, coachId: $coachId, statusId: $statusId, notes: $notes, improvementOmit: $improvementOmit, targetAvgEvents: $targetAvgEvents, targetAvgEventsSuccess: $targetAvgEventsSuccess, targetRiskScore: $targetRiskScore, targetRiskScoreSuccess: $targetRiskScoreSuccess, targetEvents: $targetEvents, targetEventsSuccess: $targetEventsSuccess, targetDistance: $targetDistance, targetDistanceSuccess: $targetDistanceSuccess) {
                        id
                    }
                }
                `,
                {
                    id,
                    coachId,
                    statusId,
                    notes,
                    improvementOmit,
                    targetAvgEvents,
                    targetAvgEventsSuccess,
                    targetRiskScore,
                    targetRiskScoreSuccess,
                    targetEvents,
                    targetEventsSuccess,
                    targetDistance,
                    targetDistanceSuccess
                },
                endpoints.GRAPHQL_GENERAL_V2
            );
            if (response) {
                return { ...response, updateStatus: updateStatus || false } || null;
            } else {
                return null
            }
        }
        catch (exc) {
            return rejectWithValue(exc.message);
        }
    }
)

export const searchRiskHistory = createAsyncThunk(
    "driverPerformance/implovementPlanTab/searchRiskHistory",
    async (payload, { rejectWithValue, getState }) => {
        try {
            const { caseNumber } = payload
            const response = await clientQuery(
                `
                query getCaseSummary ($caseNumber: String!) {
                    data: getCaseSummary (caseNumber: $caseNumber){
                        eventName
                        priorCoaching
                        events {
                            unitTime
                            deviceLabel
                            unitId
                            driverName
                            eventName
                            eventCode
                            unitType
                            deviceData
                            extraFields
                        }
                    }
                }`,
                {
                    caseNumber: caseNumber
                },
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response?.data || []
        } catch (exc) {
            return []
        }
    }
);

//Slice
const driverPerformanceImprovementPlanTabRedux = createSlice({
    name: "driverPerformance/implovementPlanTab",
    initialState: INIT_STATE,
    reducers: {
        resetImprovementPlanTab(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //searchPerformanceImprovement
        builder.addCase(searchPerformanceImprovement.pending, (state, action) => {
            state.loadingPerformanceImprovement = true;
        })
        builder.addCase(searchPerformanceImprovement.fulfilled, (state, action) => {
            state.loadingPerformanceImprovement = false;
            state.performanceImprovement = action.payload?.items || [];
            state.dateRange = action.payload?.dateRange || null;
        })
        builder.addCase(searchPerformanceImprovement.rejected, (state, action) => {
            state.loadingPerformanceImprovement = false;
            state.error = action.payload;
        })

        //updateDriverPerformanceCase
        builder.addCase(updateDriverPerformanceCase.pending, (state) => {
            state.loadingUpdateDriverPerformanceCase = true;
        })
        builder.addCase(updateDriverPerformanceCase.fulfilled, (state, action) => {
            state.loadingUpdateDriverPerformanceCase = false;
            state.updateDriverPerformanceCase = action.payload;
        })
        builder.addCase(updateDriverPerformanceCase.rejected, (state, action) => {
            state.loadingUpdateDriverPerformanceCase = false;
            state.error = action.payload;
        })

        //searchRiskHistory
        builder.addCase(searchRiskHistory.pending, (state, action) => {
            state.loadingRiskHistory = true;
        })
        builder.addCase(searchRiskHistory.fulfilled, (state, action) => {
            state.loadingRiskHistory = false;
            state.riskHistory = action.payload;
        })
        builder.addCase(searchRiskHistory.rejected, (state, action) => {
            state.loadingRiskHistory = false;
            state.error = action.payload;
        })
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceImprovementPlanTabRedux;

// Extract and export each action creator by name
export const { resetImprovementPlanTab } = actions;

// Export the reducer, either as a default or named export
export default reducer;
